var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNoResults(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.207 1.793a1 1 0 010 1.414l-3.05 3.05-9.9 9.9-3.05 3.05a1 1 0 01-1.414-1.414l2.387-2.387A8 8 0 0115.406 4.18l2.387-2.387a1 1 0 011.414 0zm-5.23 3.816a6 6 0 00-8.368 8.367l8.367-8.367zm2.948 1.932a1 1 0 011.244.674 8.005 8.005 0 01-1.35 7.19l5.388 5.388a1 1 0 01-1.414 1.414l-5.389-5.389a8.006 8.006 0 01-7.189 1.35 1 1 0 01.57-1.917 6.005 6.005 0 007.466-7.466 1 1 0 01.674-1.244z"
  })));
}
export default SvgNoResults;